import { render, staticRenderFns } from "./WidgetList.vue?vue&type=template&id=44e7bc5c&"
import script from "./WidgetList.vue?vue&type=script&lang=ts&"
export * from "./WidgetList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports